export default "__VITE_ASSET__Crr0m0h0__"